module.exports = __webpack_public_path__ + "img/smoke-01.72adc184.png";